import classNames from 'classnames';

import Filtros from '../components/Filtros'
import ResumoVotacao from '../components/ResumoVotacao'
import BuscaSecoes from '../components/buscaSecoes';

const MainPage = (props) => {

  const wrapperResumoVotacao = classNames("resumo-votacao-container w-full",{
    "flex-grow-1": props.renderVotos,    
  })
      
  return (     
    <div className="layout-main app-layout-main">              
        
        <div className="app-main-left">
          <div className="app-container main-container">
        
            <div className="container-header">
              <div className="container-title">{props.titulo}</div>
            </div>            
            
            {props.children}

          </div>
        </div>
        
        <div className="app-main-right">
          <div className="app-container main-container">
            
            {props.renderFiltro && 
                <Filtros titulo={props.filtroTitulo} 
                    renderEleicao={props.filtroEleicao} 
                    renderCargo={props.filtroCargo}
                    renderLocalidade={props.filtroLocalidade}
                    renderZE={props.filtroZE}
                    renderLocalDeVotacao={props.filtroLocalDeVotacao}/>                                     
            }
            
            <div className={wrapperResumoVotacao}>
                              
                {props.resumoTitulo &&
                    <div className="container-header">
                        <div className="container-title">{props.resumoTitulo}</div>            
                    </div>
                }
                {props.renderBusca &&                  
                    <BuscaSecoes searchField={props.searchField} handleKey={props.handleKey} iniciaBusca={props.iniciaBusca} limpaFiltro={props.limpaFiltro}/>
                }   
                            
                <ResumoVotacao 
                    acompanhamentoSecoes={props.acompanhamentoSecoes} 
                    renderVotos={props.renderVotos} 
                    renderPendencias={props.renderPendencias} pendencias={props.pendencias} pendenciasResolvidas={props.pendenciasResolvidas} />

            </div>      
            
          </div>          
        </div>
      </div>
  );
}

export default MainPage;